// extracted by mini-css-extract-plugin
export default {"container":"Items_container__GxWSV"};